import { render, staticRenderFns } from "./Device.vue?vue&type=template&id=4bda1610&scoped=true&"
import script from "./Device.vue?vue&type=script&lang=js&"
export * from "./Device.vue?vue&type=script&lang=js&"
import style0 from "./Device.vue?vue&type=style&index=0&id=4bda1610&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bda1610",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bda1610')) {
      api.createRecord('4bda1610', component.options)
    } else {
      api.reload('4bda1610', component.options)
    }
    module.hot.accept("./Device.vue?vue&type=template&id=4bda1610&scoped=true&", function () {
      api.rerender('4bda1610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Device.vue"
export default component.exports